import moment from 'moment'

export default {
  name: 'appointmentCalendar',
  data: function () {
    return {
      selectedDate: null
    }
  },

  props: {
    availableDates: Array
  },
  methods: {
    handleOnInput() {
      this.$emit(
        'clickDate',
        moment(Object(this.selectedDate)).format('DD/MM/YYYY')
      )
    }
  }
}
